import React, { Component } from 'react';
import Header from '../Header';
import styles from './SignIn.module.css';
import { connect } from 'react-redux';
import { getUser, authenticate } from '../../modules/users';
import propTypes from 'prop-types';
import ReactSelect from 'react-select';

class SignIn extends Component {
  state = { loginError: null, organization: null };
  static contextTypes = {
    router: propTypes.object,
  };
  async componentDidMount() {}

  login = () => {
    const { organization } = this.state;
    const { authenticate } = this.props;
    const email = this.refs['email'].value;
    const passwd = this.refs['password'].value;
    authenticate(email, passwd, organization).then(user => {
      if (!user) this.setState({ logInError: 'Invalid email or password.' });
    });
  };

  triggerLogin = (e, data) => {
    const key = e.key;
    if (key === 'Enter') {
      this.login();
    }
  };

  render() {
    const { user } = this.props;
    const { router } = this.context;
    const { logInError, organization } = this.state;
    if (user) {
      router.history.push('/');
    }

    return (
      <div className={styles.container}>
        <Header />
        <div className={styles.content} />
        <h3 className={styles.loginTitle}> Sign In </h3>
        <div className={styles.inputLabel}>
          Brand <span className={styles.required}>required</span>
        </div>
        <ReactSelect
          placeholder=""
          value={organization}
          style={{
            borderStyle: 'none',
          }}
          className={styles.dropDown}
          options={[
            { label: 'Crate', value: 'crate' },
            { label: 'CB2', value: 'cb2' },
          ]}
          onChange={item => this.setState({ organization: item && item.value })}
        />
        <div className={styles.inputLabel}>
          Email <span className={styles.required}>required</span>
        </div>
        <input
          className={styles.inputField}
          ref="email"
          onKeyPress={this.triggerLogin}
          onChange={item => logInError && this.setState({ logInError: null })}
        />
        <div className={styles.inputLabel}>
          Password <span className={styles.required}>required</span>
        </div>
        <input
          className={styles.inputField}
          onKeyPress={this.triggerLogin}
          onChange={item => logInError && this.setState({ logInError: null })}
          type="password"
          ref="password"
        />
        <div
          className={styles.forgotPassword}
          onClick={() => window.open(`https://clara.io/forgot_password`)}
        >
          Forgot your password?
        </div>
        {logInError && <div className={styles.loginError}> {logInError}</div>}
        <button className={styles.loginBtn} onClick={this.login}>
          Sign In
        </button>
      </div>
    );
  }
}

export default connect(
  state => ({
    user: getUser(state),
  }),
  { authenticate }
)(SignIn);



// WEBPACK FOOTER //
// ./src/containers/SignIn/index.js